import { render, staticRenderFns } from "./IngredientSelector.vue?vue&type=template&id=4a9decec&scoped=true"
import script from "./IngredientSelector.vue?vue&type=script&lang=js"
export * from "./IngredientSelector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a9decec",
  null
  
)

export default component.exports